module.exports = __webpack_public_path__ + "static/media/img1.eb2cd5b8.jpeg";